export const FollowedLabel: React.FC = () => {
  return (
    <span className="block text-[10px] leading-normal text-white">
      あなたをフォロー中
    </span>
  )
}
